export default __webpack_public_path__ + "static/media/scroll.a5a7e011.svg";